/* eslint-disable */
import Image from 'next/image';
import { useEffect, useState } from 'react';

import { useBuyRedirectStore } from '@/api/digital-gold/store/buyGoldRedirectionStore';
import {
  BuyVerifyResponseData,
  useBuyVerifyStore,
} from '@/api/digital-gold/store/buyVerifyStore';
import { useLivePriceStore } from '@/api/digital-gold/store/livePriceStore';
import { Timer } from '@/common/components/digital-gold';
import { PayButton } from '@/common/components/PayButton';

import CLock from '@/assets/images/icons/clock-icon.svg';
import GOld from '@/assets/images/icons/gold-coin-icon.svg';
import NCPI from '@/assets/images/icons/npci.svg';
import { useForm } from 'react-hook-form';
import {
  useVerifyPrice,
  verifyBuy,
  VerifyRequestParamsType,
} from '@/api/digital-gold/buyVerifyPrice';
import { useAuth } from '@/api';
import { displayError } from '@/utils/functions/displayError';
import { watch } from 'fs';
import { useNotificationStore } from '@/common';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { CustomerDetail } from '@/types';
import { useBuyConfirm } from '@/api/digital-gold/confirmBuy';
import { useBuyConfirmStore } from '@/api/digital-gold/store/buyConfirmStore';
import Loader from '@/common/components/Loader';
import { BuyStepName } from '@/utils/constants/digital-gold';
import { useFeatureFlags } from '@/api/feature-flags';
import { PaymentMethodConfig, PaymentMethods } from '@/providers/payments';
import { createMoengageEvent } from '@/utils/moengage';
import useMoengageStore from '@/store/moengage';
import moment from 'moment';

export const BuyGoldCheckout = () => {
  const [livePrice, setLivePrice] = useState(null);
  const [setBuyStep] = useBuyRedirectStore((state) => [state.setBuyStep]);
  const { userId: customerId } = useAuth();
  const { featureFlags, isFlagsFetched } = useFeatureFlags();

  const [pricedata] = useLivePriceStore((state) => [state.pricedata]);
  const [verifyData, updateResponse, buyInputGold] = useBuyVerifyStore(
    (state) => [state.verifyData, state.updateResponse, state.buyInputGold]
  );
  const { userDetails } = useAuth();
  // document.cookie = "om-auth-user=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc01waW5TZXQiOiJ0cnVlIiwiaXNGaXJzdExvZ2luIjpmYWxzZSwidXNlcl9uYW1lIjoiNzAxMjI4MzM0OSIsInNjb3BlIjpbIlJFQUQiLCJXUklURSJdLCJleHAiOjE2ODM0NTE0MDMsImN1c3RvbWVyX2lkIjoiMGU2ODIzNWEtNmZhNS00OGMwLTk3OTAtNDRmYTBhMDEyZWQyIiwianRpIjoiZWI1ZDRmNmUtMjYzMS00ODc3LTlhOWQtZDY2M2U1YmZkODM3IiwiY2xpZW50X2lkIjoiY2xpZW50SWQifQ.lwD0ubZ7b8sd4-9rSx1gFbf0UScPH1LHkBQt7TH1h-Zs-xjZNEouPqDd0f1Xa-HZCEAjcXX--qJkTPK1jxD6hv193Iz_a9F_6HFjy23uAd4KYppljbGcwsf8h2r0iADBhOStXR_9AGqnTOwxCzpLkWc5zb4psV5dT6YCrl3XMsbkzVxPu9yQuUUmA5ln2YX2Xb0vc44daddU2Arco3-ksy5vjSjf0dotc-7VCsxZmMKVV0PFgsgZiWl0n8AFsT9mDSpZhIArXQtXAEByedUCW-c8LqMCay3fdh3mp8lqng7mV8sUgnKgN4wV0C-e0zLlBM3_6QTtf32-dys8M1J5XA";
  // const [updateResponse,verifyData] = useBuyVerifyStore((state) => [
  //   state.updateResponse,
  //   state.verifyData
  // ]);

  const couponSchema = yup.object({
    coupon: yup.string().required('Enter Coupon Code'),
  });

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      coupon: '',
      couponMesage: 'Save extra now through your Coupons!',
    },
    resolver: yupResolver(couponSchema),
  });

  const { addNotification } = useNotificationStore();
  const [params, setParams] = useState<VerifyRequestParamsType>({
    customerId: '',
    blockId: '',
    goldAmountInRupee: 0,
    weightInGram: 0,
    promoCodes: null,
    previousBuyLotId: null || '',
  });

  const verifyAxiosResponse = useVerifyPrice(params);
  const buyConfirmApiResponse = useBuyConfirm();
  const [updateConfirmResponse] = useBuyConfirmStore((state) => [
    state.updateConfirmResponse,
  ]);
  const [applied, setApplied] = useState<boolean>(false);
  useEffect(() => {
    if (verifyAxiosResponse?.data?.status === 200) {
      let verifyCouponResponse: BuyVerifyResponseData =
        verifyAxiosResponse.data.data.data;
      if (
        !!verifyCouponResponse.appliedCouponCodes &&
        verifyCouponResponse.appliedCouponCodes.length > 0
      ) {
        setApplied(true);
        setValue(
          'couponMesage',
          verifyCouponResponse.appliedCouponCodes[0].message
        );
        addNotification({
          title: 'Coupon Applied',
          type: 'success',
          message: verifyCouponResponse.appliedCouponCodes[0].message,
        });
      }
      updateResponse(verifyAxiosResponse?.data?.data?.data);
    } else if (verifyAxiosResponse?.data?.status === 400) {
      addNotification({
        title: verifyAxiosResponse?.data?.statusText,
        type: 'error',
        message: verifyAxiosResponse?.data.statusText,
      });
      // setEnabled(false);
    }
  }, [verifyAxiosResponse.data?.status]);

  useEffect(() => {
    if (watch('coupon') === '') {
      onSubmit(getValues('coupon'));
      setValue('couponMesage', 'Save extra now through your Coupons!');
    }
  }, [watch('coupon')]);

  useEffect(() => {
    verifyAxiosResponse.refetch();
  }, [params]);

  useEffect(() => {
    setApplied(false);
  }, [watch('coupon')]);

  const [dgProceedToPayClicked, mobileNumber, dgPaymentAcknowledgementView] =
    useMoengageStore((state) => [
      state.dgProceedToPayClicked,
      state.mobileNumber,
      state.dgPaymentAcknowledgementView,
    ]);

  let cardOption = { method: 'card' } as const;
  let netbankingOption = { method: 'netbanking' } as const;
  let upiOption = { method: 'upi' } as const;
  let paymentOptions: Array<{ method: PaymentMethods }> = [upiOption];
  isFlagsFetched &&
    featureFlags.dg_enable_card &&
    paymentOptions.push(cardOption);
  isFlagsFetched &&
    featureFlags.dg_enable_netBanking &&
    paymentOptions.push(netbankingOption);

  const paymentStatusMoEngageEvent = (status: boolean) => {
    return createMoengageEvent(dgPaymentAcknowledgementView, {
      total_amount: verifyData.totalAmount,
      gst: verifyData.gst,
      live_buying_price: pricedata.buyGoldRate,
      created_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      service_type: 'dg',
      is_payment_success: status,
      mobile_number: mobileNumber,
    });
  };

  const onSubmit = async (data: any) => {
    const couponPayload: VerifyRequestParamsType = {
      customerId: userDetails?.id || '',
      blockId: pricedata.blockId,
      goldAmountInRupee: buyInputGold,
      weightInGram: 0,
      promoCodes: watch('coupon') !== '' ? data?.coupon : null,
      previousBuyLotId: watch('coupon') !== '' ? verifyData.buyLotId : null,
    };
    setParams(couponPayload);
    // if (getValues("coupon") !== null && userDetails?.id !== "")
    // setEnabled(true);
    // verifyAxiosResponse.refetch();
    // if (
    //   // verifyData.appliedCouponCodes !== null
    //   //  ||
    //   watch("coupon") !== "" &&
    //   prevCoupon !== watch("coupon")
    // ) {
    // const verifyAxiosResponse: any = await useVerifyPrice(
    //   couponPayload,
    //   enabled
    // );

    // else {
    //   addNotification({
    //     title: verifyAxiosResponse?.error ,
    //     type: "warning",
    //     message: verifyAxiosResponse?.error?.detail,
    //   });
    // }
    // else if (verifyAxiosResponse?.response?.status === 400) {
    //   addNotification({
    //     title: verifyAxiosResponse?.response.data.error,
    //     type: "warning",
    //     message: verifyAxiosResponse?.response.data.detail,
    //   });
    // }
    // }
    // else {
    //   console.log("enter valid coupon");
    // }
    // }
    // {
    //   useVerifyPrice(couponPayload,getValues("coupon"))
    // }
  };

  const handleClick = async () => {
    const confirmBuyParams = {
      customerId: (userDetails && userDetails.id && userDetails?.id) || '',
      phoneNum:
        (userDetails && userDetails.id && userDetails?.mobilePhone) || '',
      paymentMethod: 'UPI',
      amountPaidInRupee: verifyData.amount.toString(),
      paymentRefNo: `pay_${verifyData.buyLotId}`,
      weightInGram: '0',
      transactionStatus: 'SUCCESS',
      buyLotId: verifyData.buyLotId,
    };
    const response = await buyConfirmApiResponse.mutateAsync(confirmBuyParams);
    if (response.status === 200) {
      updateConfirmResponse(response.data.data);
      setBuyStep(BuyStepName.buyStatus);
    }
    createMoengageEvent(dgProceedToPayClicked, {
      amount: verifyData.amount.toString(),
      live_buying_price: pricedata.buyGoldRate,
      created_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      service_type: 'dg',
      gold_quantity: verifyData.weight.toString(),
      gst: verifyData.gst,
      is_sip_true: false,
    });
  };

  const removeCoupon = async () => {
    const couponPayload: any = {
      customerId: userDetails?.id,
      phoneNum: userDetails?.mobilePhone,
      blockId: pricedata.blockId,
      goldAmountInRupee: buyInputGold,
      action: 'verification',
      weightInGram: 0,
      goldPrice: pricedata.buyGoldRate,
      isSipFlow: false,
      promoCodes: null,
      // promoCodes: "MASmfNnP",
      previousBuyLotId: null,
    };
    const verifyAxiosResponse: any = await verifyBuy(couponPayload);
    if (verifyAxiosResponse.status === 200) {
      updateResponse(verifyAxiosResponse?.data?.data);
      setValue('coupon', '');
      // setPrevCoupon(watch("coupon"));
      // couponAdded = true;
      // couponVerifyError=false
    }
  };
  const payButtonClickMoengageEvent = () => {
    createMoengageEvent(dgProceedToPayClicked, {
      amount: verifyData.amount.toString(),
      live_buying_price: pricedata.buyGoldRate,
      created_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      service_type: 'dg',
      gold_quantity: verifyData.weight.toString(),
      gst: verifyData.gst,
      is_sip_true: false,
    });
  };
  return (
    <>
      <Loader show={buyConfirmApiResponse.isLoading} />
      <main className="loanDetails pledge repayment checkout visitSchedule__body singleFlow--lightBlue">
        <div className="container">
          {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#">eSwarna Digital Gold</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Buy Gold
            </li>
          </ol>
        </nav> */}
          <div className="row mt-4">
            <div className="col-lg-7">
              <div className="visitSchedule dg_checkout">
                <div className="stepper--content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="loanDetails__card loanCard">
                        <div className="loanRequirements">
                          <p className="loanCard__title text--bold text--black">
                            Checkout
                          </p>
                          <div className="livePrice withTime">
                            <div className="left">
                              <p className="liveChips text--semi text--white">
                                <span className="pulsingDot"></span> Live
                              </p>
                              <p className="text--regular text--black title">
                                Buying Price:{' '}
                                <span className="text--bold">
                                  ₹{pricedata.buyGoldRate.toString()}/gm
                                </span>
                              </p>
                            </div>
                            <div className="right">
                              <Image
                                style={{ color: undefined }}
                                className="img-fluid"
                                src={CLock}
                                alt="clock icon"
                              />
                              <p className="text--black text--regular time">
                                Valid for:
                                {/* <span className="text--bold">03:38</span> */}
                                <span className="text--bold">
                                  <Timer
                                    setLivePrice={setLivePrice}
                                    flowName="BUY"
                                  />
                                </span>
                              </p>
                            </div>
                          </div>
                          <p className="text--semi text--black loanCard__title-small">
                            Payment breakdown
                          </p>
                          {/* <div className="payable">
                            <p className="text--gray text--regular desc">
                              <span className="big">Name</span>
                            </p>
                            <p className="text--gray text--semi price">
                              Chandu
                            </p>
                          </div>
                          <div className="payable">
                            <p className="text--gray text--regular desc">
                              <span className="big">Mobile Number</span>
                            </p>
                            <p className="text--gray text--semi price">
                              9999999999
                            </p>
                          </div> */}
                          <div className="payable">
                            <p className="text--gray text--regular desc">
                              <span className="big">Gold Quantity</span>
                            </p>
                            <p className="text--gray text--semi price">
                              {verifyData.weight.toString()} gms
                            </p>
                          </div>
                          <div className="payable">
                            <p className="text--gray text--regular desc">
                              <span className="big">Gold Value</span>
                            </p>
                            <p className="text--gray text--semi price">
                              ₹{verifyData.amount.toString()}
                            </p>
                          </div>
                          <div className="payable">
                            <p className="text--gray text--regular desc">
                              <span className="big">GST (3.0%)</span>
                            </p>
                            <p className="text--gray text--semi price">
                              ₹{verifyData.gst.toString()}
                            </p>
                          </div>
                          {verifyData.appliedCouponCodes !== null && (
                            <div className="payable">
                              <p className="text--gray text--regular desc">
                                <span className="big">Coupon Offer</span>
                              </p>
                              <p className="text--gray text--semi price">
                                ₹{verifyData.promoCodeDiscountAmount.toString()}
                              </p>
                            </div>
                          )}
                          <div className="payable final">
                            <p className="text--black text--regular desc">
                              <span className="big">Total Amount Payable</span>
                            </p>
                            <p className="text--black text--bold price">
                              ₹ {verifyData.totalAmount.toString()}
                            </p>
                          </div>
                          <div className="action-container">
                            {verifyData.payableAmount === 0 ? (
                              <button
                                className="custom__button custom__button--dark text--bold w-100"
                                type="button"
                                onClick={() => handleClick()}
                                id="DG_proceed-to-pay"
                              >
                                Proceed to Pay
                              </button>
                            ) : (
                              <PayButton
                                id="DG-buy_pay_button"
                                amount={parseFloat(
                                  verifyData.payableAmount.toString()
                                )}
                                className="custom__button custom__button--dark text--bold w-100"
                                // TODO : customerId toggling
                                // customerId="0e68235a-6fa5-48c0-9790-44fa0a012ed2"
                                customerId={`${customerId}`}
                                onClickHandler={()=>{
                                  payButtonClickMoengageEvent();
                                }}
                                failureHandler={() => {
                                  // console.log('FAILED');
                                  paymentStatusMoEngageEvent(false);
                                }}
                                successHandler={(response: any) => {
                                  paymentStatusMoEngageEvent(true);
                                  setBuyStep(BuyStepName.buyStatus);
                                }}
                                productShortKey="DG"
                                // TODO : content is changed as per requirement
                                text={`Proceed to Pay`} // ${verifyData.payableAmount.toString()
                                paymentDescription="Digital Gold - Muthoot FinCorp ONE"
                                productParams={{
                                  dg: {
                                    phoneNum: `${userDetails?.mobilePhone}`,
                                    buyLotId: `${verifyData.buyLotId}`,
                                  },
                                }}
                                paymentMethods={paymentOptions}
                                // couponAmount={verifyData.promoCodeDiscountAmount}
                              />
                            )}
                            {/* <a
                          href="./buy-gold-order-summery.html"
                          className="custom__button custom__button--dark text--bold w-100"
                        >
                          Proceed to pay ₹{verifyData.payableAmount.toString()}{' '}
                        </a> */}
                          </div>
                          <div className="power">
                            <div className="item">
                              <p className="text--gray text--semi title">
                                Powered by
                              </p>
                              <Image
                                style={{ color: undefined }}
                                className="img-fluid"
                                src={NCPI}
                                alt="npci"
                              />
                            </div>
                            <div className="item shield">
                              <Image
                                style={{ color: undefined }}
                                className="img-fluid"
                                src={GOld}
                                alt="shield"
                              />
                              <p className="text--gray text--semi title">
                                24K | 99.9% Pure Gold
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 mt-3 mt-lg-0">
              <div className="loanDetails__card loanCard">
                <p className="loanCard__title text--bold text--black">
                  Coupons
                  {/* and Offers */}
                </p>
                <form
                  className={`${
                    errors.coupon
                      ? 'input-form justify-content-between error_container'
                      : 'input-form justify-content-between'
                  }`}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <input
                    type="text"
                    placeholder="Enter Coupon Code"
                    {...register('coupon')}
                  />
                  {/* {verifyData.appliedCouponCodes === null ? ( */}
                  <button
                    type="submit"
                    className={
                      applied
                        ? `text--semi coupon_button green_text`
                        : `text--semi coupon_button`
                    }
                    id="DG_apply-coupon"
                  >
                    {applied ? 'Applied!' : ' Apply'}
                  </button>
                  {/* ) : ( */}
                  {/* <p className="text--regular coupon_message green_text">Applied</p>
                )} */}
                </form>
                {errors.coupon && (
                  <p className="text--regular error_coupon">
                    {errors.coupon?.message}
                  </p>
                )}
                {!errors.coupon && (
                  <p className="text--regular dg-coupons-default-message ">
                    {getValues('couponMesage')}
                  </p>
                )}
                {/* <button type="button" onClick={() => removeCoupon()}>
                Remove
              </button> */}
              </div>
            </div>
          </div>
          <p className="text--gray text--regular pledge__info">
            <span className="text--darkBlue text--bold">Note:</span> You will be
            redirected to our payment provider Razorpay's website to complete
            your payment.{' '}
          </p>
        </div>
      </main>
    </>
  );
};
